import React, { useEffect, useState } from 'react'
import { MDBBtn, MDBCard, MDBCardBody, MDBCardImage, MDBCardText, MDBCardTitle, MDBCheckbox, MDBRow, MDBTypography } from 'mdb-react-ui-kit'
import { isoToGermanDate } from '../../../../utils/dateTools'
import { useTranslation } from 'react-i18next'
import { transformMoney } from "../../../../utils/money"

export default function EventAndTicket({event, params, setParams, handleClickPrev, handleClickNext, taxRate = 19}) {
    const { t, i18n } = useTranslation()

    const [isValid, setIsValid] = useState(true);

    const checkValidity = () => {
        if (params.ticketType) {
            setIsValid(true);
            return true;
        } else {
            setIsValid(false);
            return false;
        }
    }

    useEffect(() => {
        if(params.ticketType) checkValidity();
    }, [params.ticketType]);

    const handleClickButton = () => { 
        if (checkValidity()) handleClickNext();
    }



  return (
<>
<MDBTypography tag='h2' className="mb-lg-4">{t("Event")}</MDBTypography>
{event && 
<>
    <MDBCard className="mb-2 col-lg-4 mx-auto">
    {event.image?.fileName &&
    <MDBCardImage src={"https://iec-cp-public.s3.eu-central-1.amazonaws.com/EventImages/" + event.image.fileName} position='top' alt='...' />}
    <MDBCardBody>
        <MDBCardTitle>{event.name.find(t => t.language === i18n.language)?.text || event.name[0].text}</MDBCardTitle>
        <MDBCardText>
        {isoToGermanDate(event.startDate)} - {isoToGermanDate(event.endDate)}<br></br>
        {event.location?.address?.city}</MDBCardText>
    </MDBCardBody>
</MDBCard>

<MDBRow className="my-2 my-xl-4 px-xl-5" style={!isValid ? {color: "red"} : {}}>
<MDBTypography tag='h2' className="my-lg-4" translate="no">{t("Ticket")}</MDBTypography>
<MDBTypography tag='h4' className="mb-lg-3">{t("Select your ticket type")}</MDBTypography>
    <div className="col-lg-6 mx-auto">
    <MDBCard
        onClick={e => setParams(old => ({...old, ticketType: "default", visitorType: "visitor"}))}
        shadow='0'
        background={params.ticketType === "default" && params.visitorType !== "staff" ? "success bg-opacity-10" : "white"}
        className={(params.ticketType === "default" && params.visitorType !== "staff" ? " border-success" : "")}
        style={{border: "1px solid", cursor: "pointer"}}
        >
            <MDBCardBody className='text-primary text-start'>
            <MDBCardTitle>{t("Visitor-Ticket")}
            {/* <span className="float-end">0€* <span className="text-danger fw-light text-decoration-line-through">100€</span></span> */}
            <span className="float-end fs-6">
              {transformMoney(event.ticketProduct?.price * (1 + taxRate / 100))}
              {event.ticketPricePerDay && <small className="ms-1">/ {t("Day")}</small>}
              <br />
              <small className="text-muted fw-normal">
                {taxRate > 0 ? t("inkl. {{taxRate}}% MwSt", { taxRate }) : t("Net (VAT exempt)")}
              </small>
            </span>
            </MDBCardTitle>
            <div className="text-start">
            <ul>
            {event.bookingTicketBulletPoints?.map((bullet, index) => <li key={index}>{bullet.text.find(t => t.language === i18n.language)?.text || bullet.text[0].text}</li>)}
            </ul>
            </div>
            <div className="text-center">
            <strong>{t("Select")}</strong>
            </div>
            </MDBCardBody>
        </MDBCard>
    {event?.enableStaffBooking &&
    <MDBCard
        onClick={e => setParams(old => ({...old, ticketType: "default", visitorType: "staff"}))}
        shadow='0'
        background={params.visitorType === "staff" ? "success bg-opacity-10" : "white"}
        className={"mt-3" + (params.visitorType === "staff" ? " border-success" : "")}
        style={{border: "1px solid", cursor: "pointer"}}
        >
            <MDBCardBody className='text-primary text-start'>
            <MDBCardTitle>{t("Booth Staff Ticket")}
            <span className="float-end fs-6">
              {transformMoney(event.ticketProduct?.price * (1 + taxRate / 100))}
              {event.ticketPricePerDay && <small className="ms-1">/ {t("Day")}</small>}
              <br />
              <small className="text-muted fw-normal">
                {taxRate > 0 ? t("inkl. {{taxRate}}% MwSt", { taxRate }) : t("Net (VAT exempt)")}
              </small>
            </span>
            </MDBCardTitle>
            <div className="text-start">
            <ul>
            {event.bookingTicketBulletPoints?.map((bullet, index) => <li key={index}>{bullet.text.find(t => t.language === i18n.language)?.text || bullet.text[0].text}</li>)}
            <li>{i18n.language === "de" ? "Einlass zur Veranstaltung 30 Minuten vor Veranstaltungsbeginn" : "Admission to the event 30 minutes before the event starts"}</li>
            </ul>
            </div>
            <div className="text-center">
            <strong>{t("Select")}</strong>
            </div>
            </MDBCardBody>
        </MDBCard>
    }
    </div>
    {/* <MDBCol>
    <MDBCard
        onClick={e => setParams(old => ({...old, ticketType: "premium"}))}
        shadow='0'
        background={params.ticketType === "premium" ? "success bg-opacity-10" : "white"}
        className={"h-100" + (params.ticketType === "premium" ? " border-success" : "")}
        style={{border: "1px solid", cursor: "pointer"}}
        >
            <MDBCardBody className='text-primary text-start'>
            <MDBCardTitle>{t("Premium-Ticket")}<span className="float-end">500€* <span className="text-danger fw-light text-decoration-line-through">1000€</span></span></MDBCardTitle>
            <MDBCardText className="text-start">
            <ul>
            <li>{t("Access to the event on the selected days")}</li>
            <li>{t("Over 200 technical, educational and marketing lectures from more than 200 exhibitors")}</li>
            <li>{t("Free food and drinks and participation in 2 special themed evenings")}</li>
            <li><strong>{t("Access to the recordings of all technical and educational lectures")}</strong></li>
            </ul>
            <span className="float-end mt-1">
            <small>*{t("Price for bookings and payment until 15.04.2024 and visitors that attend the event.")}</small>
            </span>
            </MDBCardText>
            <div className="text-center" style={{ bottom: "0.5rem", position: "absolute", width: "-webkit-fill-available"}}>
            <strong>{t("Select")}</strong>
            </div>
            </MDBCardBody>
        </MDBCard>
    </MDBCol> */}

    <div className="text-center mt-4">
    <MDBBtn color="primary" onClick={handleClickButton}>{t("Next")}</MDBBtn>
    </div>
</MDBRow>
</>
}
</>
  )
}
